//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsRevealButtons', [
    'TrackingService',
    'UniversalImageActionsService',
    'UniversalImageActionsView',
    function(
            TrackingService,
            UniversalImageActionsService,
            UniversalImageActionsView,
        ) {
      return {
        restrict: 'E',
        scope: {},
        template: require('@legacy-components/common/universal-image-actions/universal-image-actions-reveal-buttons.html'),
        link(scope) {
          const workflow = UniversalImageActionsService.getCurrentWorkflow();

          scope.model = {};

          scope.model.disableDoneButton = function() {
            return workflow.getCurrentState() !== UniversalImageActionsView.Reveal.name &&
                            workflow.getCurrentState() !== UniversalImageActionsView.Reveal2.name &&
                            workflow.getCurrentState() !== UniversalImageActionsView.Revolve.name;
          };

          scope.model.close = function() {
            scope.$emit('uia:modal:close', {
              result: {
                actionCompleted: TrackingService.ACTION_REVEAL,
              },
            });
          };
        },
      };
    },
  ]);
})();
